import {IWixSdk} from '@wix/js-sdk-wrapper';
import {SiteStorage as SharedSiteStorage} from '@wix/music-shared/dist/src/site-storage/site-storage';
import {inject, injectable, decorate} from 'inversify';
import {services} from '../../ioc/services';
import {ViewModes} from '../../widget-player/new/viewMode';
import {IGlobal} from '../Global/IGlobal';
import {ISiteStorage} from './ISiteStorage';

export class SiteStorage implements ISiteStorage {
  private readonly siteStorage: SharedSiteStorage;

  constructor(private readonly WixSdk: IWixSdk, private readonly global: IGlobal) {
    const isInSite = WixSdk.Utils.getViewMode() === ViewModes.Site;
    const widgetData = isInSite ? global.getWidgetData() : undefined;

    this.siteStorage = new SharedSiteStorage({
      prefix: 'wmp',
      WixSdk,
      data: widgetData?.data,
      style: widgetData?.style as any,
    });
  }

  get<T = string>(key: string): Promise<T | undefined> {
    return this.siteStorage.get(key);
  }
}

decorate(injectable(), SiteStorage);
decorate(inject(services.WixSdk) as ParameterDecorator, SiteStorage, 0);
decorate(inject(services.global) as ParameterDecorator, SiteStorage, 1);
